import React from "react"
import autobind from "class-autobind"
import strings from "../../../../../../localization/strings"
import FinddDatePicker from "../../../../../../components/common/FinddDatePicker"
import TextChip from "../../../../../../components/common/TextChip"
import { TextField, FontIcon } from "material-ui"
import moment from "moment"
import { blueGrey500 } from "material-ui/styles/colors"

interface IProps {
    field
    value
    onChange(key, value): void
}

interface IState {
}

export default class FormTextChipSetField extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        autobind(this);
    }

    render() {
        const { field, value, onChange } = this.props;
        return (
            <span>

                <TextChip
                    title={field.label}
                    titleStyle={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}
                    chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
                    addButtonStyle={{ height: 40, marginTop: 2, marginLeft: -5, display: "inline-block" }}
                    allData={value}  // Pass the current dates array
                    handleChange={dates => onChange(field.name, dates)}  // Update parent with new dates array
                    onChange={(_e, value) => onChange(field.name, value)}
                    error={""}
                    handleSnackbarAlertContent={snackbarAlertContent => this.setState({ snackbarAlertContent })}
                />       
            </span>
        );
    }
}